/** Outline schedule chip label: the compact rule, plus the task's own start when it overrides the line's. */
import { ScheduleRule } from '@jms/model/scheduling/schedule.rule';

const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const;

/**
 * A stored `startsOn` is always a genuine override — the API normalises away a value that merely
 * repeats the line's effectiveFrom — so its presence alone earns the clause; no equality check here.
 * A template row never carries one, so the clause simply never fires on that side.
 *
 * Only a cadence has a start to shift, so the clause is limited to the kinds that have one: an
 * explicit 'calendar', and an ABSENT schedule, which the engine reads as the working-day default.
 * 'dates' is the pointed exclusion — `describeShort` already spells the list out ("13 Aug · 24 Sep",
 * "N dates" past the cap), and a hand-picked list has no cadence for a start date to anchor, so the
 * clause would only contradict the dates already on the chip. 'perVisit' and 'afterService' are
 * likewise anchorless: one rides the visit, the other chains off the last completion.
 */
export function outlineScheduleChipLabel(describeShort: string, schedule: ScheduleRule | undefined, startsOn: string | undefined): string {

  if (!startsOn || (schedule && schedule.kind !== 'calendar')) return describeShort;
  return `${describeShort} · from ${outlineScheduleChipDate(startsOn)}`;
}

/** YYYY-MM-DD to the chip's short form, e.g. '2026-09-15' → '15 Sep'. */
export function outlineScheduleChipDate(date: string): string {

  const month = MONTH_LABELS[Number(date.slice(5, 7)) - 1];
  if (!month) return date;
  return `${Number(date.slice(8, 10))} ${month}`;
}
